
let ENDPOINT = process.env.REACT_APP_API_URL;


export const useClientRequest = () => {
    const request = async (query, options = {}) => {
        const { headers, body } = options

        if (body && !body.has) {
            options.headers = {
                ...headers,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
            options.body = JSON.stringify(body)
        }

        const csrf = sessionStorage.getItem('csrf')
        if (csrf) {
            options.headers = {
                ...options.headers,
                'X-Bitrix-Csrf-Token': csrf,
            }
        }

		  console.log('options=>',options)

        let data;
        const response = await fetch(ENDPOINT + query, { ...options })
        
        if(response.status === 200){
            data = await response.json()
        }


        if (Array.isArray(data)) {
            return data
        } else {
            return { ...data, statusCode: response.status }
        }
    }



    const getAjaxContent = async (path, body, headers={}) => {
        const method = body ? 'POST' : 'GET'
        return await request(path, {
            method,
            body,
				headers,
        })
    }


    const getFormScheme = async (id) => {
        return await request(`/slam.scheme.get?id=${id}`, {
            method: 'GET',
        })
    }



    return {
      getAjaxContent,
      getFormScheme,
    }
}
